<template>
  <div v-if="page">
    <h1 class="text-3xl font-normal">{{ page.post_title }}</h1>

    <div class="max-w-prose">
      <div v-html="page.content.rendered" class="rendered"></div>
    </div>
  </div>
</template>

<script>
  import store from '@/store'

  export default {
    name: 'AppPage',
    computed: {
      slug () {
        return this.$route.meta.slug
      },
      page () {
        return this.$store.state.pages[this.slug] || {}
      }
    },
    beforeRouteEnter (to, _from, next) {
      const { slug } = to.meta
      store.dispatch('getPage', slug).then(() => {
        next()
      })
    },
    mounted () {
      console.log(this.page)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/AppPage.vue